import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface UserAlert {
  userAlertId: number;
  triggeredOn: string;
  alertTitle: string;
  alertDescription: string;
  alertType: string;
}

export interface WelcomeAlert {
  userAlertId: string;
  triggeredOn: string;
  alertTitle: string;
  alertDescription: string;
  alertType: string;
  alertLevel?: string;
  clientId?: string;
  workspaceId?: string;
  projectId?: string;
  reportType?: string;
}
export interface CustomAlert {
  userAlertId: number;
  triggeredOn: string;
  alertTitle: string;
  alertDescription: string;
  alertType: string;
  alertLevel?: string;
  clientId?: string;
  projectId?: string;
  reportType?: string;
  projectName?: string;
}

interface AlertsState {
  alerts: UserAlert[];
  welcomeScreenAlerts: WelcomeAlert[];
}

const initialState: AlertsState = {
  alerts: [],
  welcomeScreenAlerts: [],
};

const alertSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setAlerts: (state, action: PayloadAction<UserAlert[]>) => {
      state.alerts = action.payload;
      console.log(action.payload);
    },
    setWelcomeScreenAlerts: (state, action: PayloadAction<WelcomeAlert[]>) => {
      state.welcomeScreenAlerts = action.payload;
      console.log(action.payload);
    },
  },
});

export const {setAlerts, setWelcomeScreenAlerts} = alertSlice.actions;
export default alertSlice.reducer;
